/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * base64Url
 */
export type ParamsBodyfileBase64UsingPost = string;
/**
 * url
 */
export type ParamsBodyfileByUrlUsingPost = string;
/**
 * @description fileFileIdUsingGet参数
 * @property `fileId` 文件id
 * @property `[alt]` alt为auto时是预览 其他均为下载
 */
export interface ParamsfileFileIdUsingGet {
  // pathParams
  /**
   * 文件id
   */
  fileId: string;
  // queryParams
  /**
   * alt为auto时是预览 其他均为下载
   */
  alt?: string;
}
/**
 * @description fileMultiUploadUsingPost参数
 * @property `[file]` 上传的文件
 */
export interface ParamsfileMultiUploadUsingPost {
  // formParams
  /**
   * 上传的文件
   */
  file?: Array<any>;
}
/**
 * @description fileUploadUsingPost参数
 * @property `[file]` 上传的文件
 */
export interface ParamsfileUploadUsingPost {
  // formParams
  /**
   * 上传的文件
   */
  file?: any;
}
/**
 * @description fileUsingPost参数
 * @property `[file]` 上传的文件
 */
export interface ParamsfileUsingPost {
  // formParams
  /**
   * 上传的文件
   */
  file?: any;
}
export class FileApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 用base64上传图片并且获得预览地址以及图片id
   
   * @param data: ParamsBodyfileBase64UsingPost// base64Url
   * @param opt ajax config
   * @returns models.CommonResultFileDTO
   */
  public fileBase64UsingPost = (
    data: ParamsBodyfileBase64UsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultFileDTO> => {
    const path = '/api/file/base64';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.base64Url');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用url上传图片并且获得预览地址以及图片id
   
   * @param data: ParamsBodyfileByUrlUsingPost// url
   * @param opt ajax config
   * @returns models.CommonResultFileDTO
   */
  public fileByUrlUsingPost = (
    data: ParamsBodyfileByUrlUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultFileDTO> => {
    const path = '/api/file/by-url';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.url');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 文件获取资源接口
   * @param params ParamsfileFileIdUsingGet
   
   * @param opt ajax config
   * @returns models.ResponseEntity
   */
  public fileFileIdUsingGet = (
    params: ParamsfileFileIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.ResponseEntity> => {
    const path = '/api/file/{fileId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('alt' in params) p.query.alt = params.alt;
    ajax.check(params.fileId, 'fileId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 多文件上传,返回文件id 获得预览下载地址
   * @param params ParamsfileMultiUploadUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResultListFileDTO
   */
  public fileMultiUploadUsingPost = (
    params: ParamsfileMultiUploadUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListFileDTO> => {
    const path = '/api/file/multi-upload';
    const url = this.$basePath + path;
    const p: any = {};
    p.form = {};
    if ('file' in params) p.form.file = params.file;
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 上传文件接口,返回文件id
   * @param params ParamsfileUploadUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResultstring
   */
  public fileUploadUsingPost = (
    params: ParamsfileUploadUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultstring> => {
    const path = '/api/file/upload';
    const url = this.$basePath + path;
    const p: any = {};
    p.form = {};
    if ('file' in params) p.form.file = params.file;
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 上传文件接口,返回文件id 获得预览下载地址
   * @param params ParamsfileUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResultFileDTO
   */
  public fileUsingPost = (
    params: ParamsfileUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultFileDTO> => {
    const path = '/api/file';
    const url = this.$basePath + path;
    const p: any = {};
    p.form = {};
    if ('file' in params) p.form.file = params.file;
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new FileApi();
